import { Component, Input, OnInit } from "@angular/core";
import { SharedService } from "../../../services";

@Component({
    selector: "app-donut-chart",
    templateUrl: "./donut-chart.component.html",
    styleUrls: ["./donut-chart.component.scss"],
})
export class DonutChartComponent implements OnInit
{

    @Input() unitsUsed: number;
    @Input() percentRemaining: number;
    @Input() unitsRemaining: number;
    @Input() isActive: boolean; // for watermark

    public data: any;

    constructor(
        public sharedService: SharedService // for watermark
    ) { }

    ngOnInit(): void
    {
    }
}
